<template>
  <div class='footer'>
      <img src="@/assets/images/home/logo.png" />
      <div class="footer-first">
          <div>{{$t('footer.bqDesc')}}</div>
           <div>{{$t('footer.smAddr')}}</div>
      </div>
      <div class="footer-second">
        <div>©ALIMAMA MUX, powered by alimama THX.</div>
        <div>{{$t('footer.bqDesc')}}</div>
        <div>{{$t('footer.beiAn')}}</div>
      </div>
      <img class="hiden-img" src="@/assets/images/home/footer_hiden.png" />

      <!-- 标签 -->
      <div class="label-container">
          <img src="@/assets/images/home/icon_email.png" />
          <img src="@/assets/images/home/icon_send.png" />
          <img src="@/assets/images/home/icon_fei.png" />
          <img src="@/assets/images/home/icon_facebook.png" />
      </div>
  </div>
</template>
<script>
export default {
};
</script>

<style lang="scss" scoped>
 .footer {
    width: 100vw;
    height: 264px;
    position: relative;
    background-image: url('../assets/images/home/footer_bg.png');
    background-size: cover;
    background-repeat:no-repeat;
    background-position:center;
    padding: 45px 130px 41px 67px;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #BBBDC6;
    .footer-first {
        margin-top: 25px;
    }
    .footer-first>div, .footer-second>div {
        margin-bottom: 5px;
    }
    .footer-second {
        margin-top: 29px;
    }
    .hiden-img {
        position: absolute;
        z-index: 1;
        right: 100px;
        top: 0;
    }
    .label-container {
        display: flex;
        position: absolute;
        right: 10%;
        bottom: 52px;
        img {
            width: 36px;
            height: 36px;
            margin-right: 39px;
        }
    }
 }
</style>
